'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCasAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.05176e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33332 20 -1.0848e-05 20C-1.0848e-05 13.3333 0.000115926 6.66667 -3.05176e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.05176e-05 0H28V20H-1.0848e-05L-3.05176e-05 0Z",
          fill: "#19BFBF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.48239 8.36852C5.40006 8.53318 5.46681 8.73341 5.63147 8.81574L7.70185 9.85093C7.86651 9.93326 7.93325 10.1335 7.85092 10.2981L7.48239 11.0352C7.40006 11.1999 7.19984 11.2666 7.03518 11.1843L6.07037 10.7019C6.02409 10.6787 5.97305 10.6667 5.9213 10.6667H4.33332C4.14923 10.6667 3.99999 10.8159 3.99999 11V11.7597C3.99999 11.9032 4.0918 12.0306 4.22791 12.076L5.48832 12.4961C5.7234 12.5745 5.79383 12.8728 5.61862 13.048L5.43095 13.2357C5.36844 13.2982 5.33332 13.383 5.33332 13.4714V13.9459C5.33332 13.9817 5.3391 14.0173 5.35043 14.0513L5.95633 15.869C5.98428 15.9529 6.04441 16.0222 6.12348 16.0617L7.11843 16.5592C7.24676 16.6234 7.40175 16.5982 7.50321 16.4968L9.0063 14.9937C9.16718 14.8328 9.12317 14.5616 8.91967 14.4598L8.18425 14.0921C8.07132 14.0357 7.99999 13.9202 7.99999 13.794V13.7603C7.99999 13.5434 8.20378 13.3843 8.41417 13.4369L10.4142 13.9369C10.5626 13.974 10.6667 14.1073 10.6667 14.2603V15.2324C10.6667 15.2982 10.6861 15.3626 10.7226 15.4173L11.901 17.1849C11.9629 17.2776 12.0669 17.3333 12.1784 17.3333H12.441C12.5773 17.3333 12.6998 17.2503 12.7505 17.1238L13.7243 14.6892C13.8311 14.4221 14.2033 14.4067 14.3319 14.6639L14.6425 15.285C14.6585 15.317 14.6796 15.3462 14.7049 15.3716L15.9617 16.6284C15.9871 16.6538 16.0163 16.6748 16.0484 16.6909L16.8509 17.0921C17.0726 17.2029 17.3333 17.0418 17.3333 16.794V16.1381C17.3333 16.0497 17.2982 15.9649 17.2357 15.9024L16.9024 15.569C16.7722 15.4389 16.7722 15.2278 16.9024 15.0976L17.2357 14.7643C17.2982 14.7018 17.383 14.6667 17.4714 14.6667H18.588C18.6397 14.6667 18.6908 14.6546 18.737 14.6315L19.8157 14.0921C19.9287 14.0357 20 13.9202 20 13.794V12.8047C20 12.7163 19.9649 12.6315 19.9024 12.569L19.569 12.2357C19.4389 12.1055 19.4389 11.8945 19.569 11.7643L20.3396 10.9937C20.5005 10.8328 20.7717 10.8768 20.8735 11.0803L21.2509 11.8352C21.3014 11.9362 21.4047 12 21.5176 12C21.7392 12 21.8834 11.7668 21.7843 11.5685L21.4824 10.9648C21.4001 10.8001 21.4668 10.5999 21.6315 10.5176L22.3685 10.1491C22.5332 10.0667 22.5999 9.86652 22.5176 9.70186L22.0617 8.79016C22.0222 8.71109 21.9529 8.65096 21.869 8.623L20.5117 8.17056C20.2766 8.0922 20.2062 7.79384 20.3814 7.61863L21.2357 6.7643C21.2982 6.70179 21.383 6.66667 21.4714 6.66667H23.1273C23.2536 6.66667 23.369 6.59533 23.4255 6.4824L23.7816 5.77015C23.8866 5.56018 23.7474 5.31037 23.5136 5.28912L17.3754 4.7311C17.094 4.70551 16.9701 4.36327 17.1699 4.16343L17.2357 4.09763C17.2982 4.03512 17.3333 3.95033 17.3333 3.86193V3C17.3333 2.81591 17.1841 2.66667 17 2.66667H14.1381C14.0497 2.66667 13.9649 2.70179 13.9024 2.7643L12.0653 4.60138C12.0226 4.6441 11.969 4.67441 11.9104 4.68906L6.78628 5.97009C6.70909 5.98939 6.62754 5.98044 6.55637 5.94485L6.0531 5.69322C5.78749 5.56041 5.49389 5.81505 5.5878 6.09678L5.95633 7.20235C5.98428 7.28622 5.97778 7.37776 5.93824 7.45683L5.48239 8.36852ZM9.99999 10.6667C10.3682 10.6667 10.6667 10.3682 10.6667 10C10.6667 9.63181 10.3682 9.33333 9.99999 9.33333C9.6318 9.33333 9.33332 9.63181 9.33332 10C9.33332 10.3682 9.6318 10.6667 9.99999 10.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.6667 16.6667C14.6667 17.0349 14.3682 17.3333 14 17.3333C13.6318 17.3333 13.3333 17.0349 13.3333 16.6667C13.3333 16.2985 13.6318 16 14 16C14.3682 16 14.6667 16.2985 14.6667 16.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22.6667 12.6667V13.3333L21.9024 14.0976C21.6924 14.3076 21.8411 14.6667 22.1381 14.6667H22.4606C22.5869 14.6667 22.7023 14.5953 22.7588 14.4824L23.3333 13.3333L22.6667 12.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22.6667 12.6667L23.0352 12.4824C23.2755 12.3622 23.19 12 22.9213 12C22.7807 12 22.6667 12.114 22.6667 12.2546V12.6667Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagCasAsset = forwardRef(FlagCasAsset);

export { VpFlagCasAsset as default };
